module.exports = __webpack_public_path__ + "img/12.4454ff8d.jpg";